import React, { useState } from "react";
import AddPaymentMethod from "./AddPaymentMethod";
import SavedPaymentMethods from "./SavedPaymentMethods";

// The advertiser's mirror of the broadcaster's "Payout & balance": one place
// for the money side, rather than payment methods being buried at the bottom
// of the profile page where a broadcaster's payout settings are not.
//
// Both components already existed and were rendered inside CustomerProfile.
// This is the same pair on their own tab; nothing here is new behaviour.

export default function CustomerPayment() {
    // Bumped when a card is added, so the saved list refetches instead of
    // showing a stale set until the page is reloaded.
    const [changed, setChanged] = useState(0);

    return (
        <div className="wb-stack">
            <div className="wb-page-head">
                <h2>Payment methods</h2>
                <p className="wb-sub">
                    Cards are held by Stripe. WallBurst stores a reference, never the
                    card number.
                </p>
            </div>

            <SavedPaymentMethods methodsChanged={changed} />
            <AddPaymentMethod onMethodAdded={() => setChanged((n) => n + 1)} />
        </div>
    );
}
